import {Component, OnInit, OnDestroy} from '@angular/core';

import {config} from '../smartadmin.config';

import {LayoutService} from './layout.service'
import {Subscription} from 'rxjs/Rx';

declare var $: any;

@Component({
  selector: 'sa-layout-switcher',
  templateUrl: './layout-switcher.component.html'
})
export class LayoutSwitcherComponent implements OnInit, OnDestroy {
  isActivated: boolean;
  smartSkin: string;
  store: any;
  private sub: Subscription;

  constructor(public layoutService: LayoutService) {}

  ngOnInit() {
    this.sub = this.layoutService.subscribe((store) => {
      this.store = store;
    });
    this.store = this.layoutService.store;
  }

  ngOnDestroy() {
    this.sub.unsubscribe()
  }

  onToggle() {
    //$('#layoutOptionsDlg').hide();
    $('#layoutOptionsDlg').modal('hide');
  }

  onSmartSkin(skin) {
    this.layoutService.onSmartSkin(skin)
  }

  onFixedHeader() {
    // this.layoutService.onFixedHeader(); // www
    let me = this;
    setTimeout(function() {
      me.layoutService.onFixedHeader();
    }, 0);
  }

  onFixedNavigation() {
    // this.layoutService.onFixedNavigation(); // www
    let me = this;
    setTimeout(function() {
      me.layoutService.onFixedNavigation();
    }, 0);
  }

  onFixedRibbon() {
    // this.layoutService.onFixedRibbon(); // www
    let me = this;
    setTimeout(function() {
      me.layoutService.onFixedRibbon();
    }, 0);
  }

  onFixedPageFooter() {
    // this.layoutService.onFixedPageFooter(); // www
    let me = this;
    setTimeout(function() {
      me.layoutService.onFixedPageFooter();
    }, 0);
  }

  onInsideContainer() {
    // this.layoutService.onInsideContainer(); // www
    let me = this;
    setTimeout(function() {
      me.layoutService.onInsideContainer();
    }, 0);
  }

  onRtl() {
    // this.layoutService.onRtl(); // www
    let me = this;
    setTimeout(function() {
      me.layoutService.onRtl();
    }, 0);
  }

  onMenuOnTop() {
    // this.layoutService.onMenuOnTop(); // www
    let me = this;
    setTimeout(function() {
      me.layoutService.onMenuOnTop();
    }, 0);
  }

  onColorblindFriendly() {
    // this.layoutService.onColorblindFriendly(); // www
    let me = this;
    setTimeout(function() {
      me.layoutService.onColorblindFriendly();
    }, 0);
  }

  factoryReset() {
    this.layoutService.factoryReset()
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/layout-switcher.component.ts